/* eslint-disable-next-line  no-unused-vars */
import React, { createElement, useContext, useEffect, useState } from "react";
import { Tooltip, TextField, Container, Box, Alert } from "@mui/material";
import ModalDialog from "./ModalDialog";
import PropTypes from "prop-types";
import loaderHelper from "../loader/loaderHelper";
import axios from "axios";
import { InfoOutlined } from "@mui/icons-material";

const baseUrl = process.env.API_GATEWAY || "https://satmon.fly.dev";

export default function GlobalConfiguration(props) {
  const { openDialog, setOpenDialog } = props;
  const [option, setOption] = useState({
    min_cnr_db: 0.0,
    impl_margin_db: 0.0,
    availability_percent: 99.0,
  });

  const [messageOption, setMessageOption] = useState({
    show: false,
    severity: "success",
    messageText: "",
  });

  useEffect(() => {
    if (openDialog) fetchGlobalConfigData();
  }, [openDialog]);

  const onCloseFunc = () => {
    setOpenDialog(false);
    loaderHelper().close();
  };

  const buttonOkClicked = async () => {
    loaderHelper().open();
    showAlerMessage(
      "Saving global configuration...",
      "info"
    );
    await saveConfigData();
    setOpenDialog(false);
    loaderHelper().close();
  };

  const showAlerMessage = (text, severity) => {
    setMessageOption({
      ...messageOption,
      severity: severity,
      messageText: text,
      show: true,
    });
  };

  const saveConfigData = async () => {
    try {
      const response = await axios.post(baseUrl + "/global-link-params", {
        min_cnr_db: parseFloat(option.min_cnr_db).toFixed(2),
        impl_margin_db: parseFloat(option.impl_margin_db).toFixed(2),
        availability_percent: parseFloat(option.availability_percent).toFixed(
          2
        ),
      });

      showAlerMessage(
        "Configuration succesfully saved for ",
        "success"
      );

      console.log(response);
    } catch (error) {
      console.error("Error fetching configuration data:", error);
      showAlerMessage(
        "Error while saving configuration ",
        "error"
      );
    }
  };

  const fetchGlobalConfigData = async () => {
    loaderHelper().open();
    showAlerMessage("Fetching global configuration", "info");

    try {
      const response = await fetch(baseUrl + "/global-link-params");
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const result = await response.json();
      if (result.length > 0) {
        const data = result[result.length - 1];

        setOption({
          min_cnr_db: data.min_cnr_db,
          impl_margin_db: data.impl_margin_db,
          availability_percent: data.availability_percent,
        });
        showAlerMessage("Configuration listed", "success");
      }
    } catch (error) {
      showAlerMessage("Failed to fetch configuration", "error");
    } finally {
    }

    loaderHelper().close();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (
      (name === "availability_percent" || name === "impl_margin_db") &&
      (value < 0 || value > 100)
    )
      return;
    if (name === "min_cnr_db" && (value < 0 || value > 1000)) return;

    setOption({
      ...option,
      [name]: value,
    });
  };

  return (
    <ModalDialog
      dialogTitle={"Global Configuration Screen"}
      openModal={openDialog}
      setOpenModal={setOpenDialog}
      onSubmit={buttonOkClicked}
      submitButtonText={"Save"}
      onCancel={onCloseFunc}
      dialogContent={
        <>
          <Container maxWidth="sm">
            <Box component="form" onSubmit={buttonOkClicked} sx={{ mt: 3 }}>
              <TextField
                fullWidth
                label="Minimum CNR (dB)"
                name="min_cnr_db"
                type="number"
                onChange={handleChange}
                value={option.min_cnr_db}
                margin="normal"
              />

              <TextField
                name="impl_margin_db"
                fullWidth
                label="Implementation Margin (dB)"
                type="number"
                onChange={handleChange}
                value={option.impl_margin_db}
                margin="normal"
              />
              <TextField
                name="availability_percent"
                fullWidth
                label="Availability Percentage"
                type="number"
                onChange={handleChange}
                value={option.availability_percent}
                margin="normal"
              />
            </Box>

            {messageOption.show && (
              <Alert
                icon={<InfoOutlined fontSize="inherit" />}
                severity={messageOption.severity}
              >
                {messageOption.messageText}
              </Alert>
            )}
          </Container>
        </>
      }
    />
  );
}

GlobalConfiguration.propTypes = {
  openDialog: PropTypes.bool.isRequired,
  setOpenDialog: PropTypes.func.isRequired,
};
